import { type BillingQueries, defBillingQueries } from '@kizen/query/billing';
import AxiosService from '__services/AxiosService';

const queries: BillingQueries = defBillingQueries(AxiosService);

export const getSummaryUsageQuery: BillingQueries['getSummaryUsageQuery'] =
  queries.getSummaryUsageQuery;

export const getBillingLicensePlansQuery: BillingQueries['getBillingLicensePlansQuery'] =
  queries.getBillingLicensePlansQuery;

export const getBusinessLicenseQuery: BillingQueries['getBusinessLicenseQuery'] =
  queries.getBusinessLicenseQuery;

export const getPaymentMethodsQuery: BillingQueries['getPaymentMethodsQuery'] =
  queries.getPaymentMethodsQuery;

export const createSetupIntentQuery: BillingQueries['createSetupIntentQuery'] =
  queries.createSetupIntentQuery;

export const getScheduledBusinessLicensesQuery: BillingQueries['getScheduledBusinessLicensesQuery'] =
  queries.getScheduledBusinessLicensesQuery;

export const getBillingSettingsQuery: BillingQueries['getBillingSettingsQuery'] =
  queries.getBillingSettingsQuery;

export const getInvoicesPageQuery: BillingQueries['getInvoicesPageQuery'] =
  queries.getInvoicesPageQuery;

export const getAIUsageCyclesQuery: BillingQueries['getAIUsageCyclesQuery'] =
  queries.getAIUsageCyclesQuery;

export const getAIUsageSummaryQuery: BillingQueries['getAIUsageSummaryQuery'] =
  queries.getAIUsageSummaryQuery;

export const getAIUsageAgenticWorkflowsBreakdownQuery: BillingQueries['getAIUsageAgenticWorkflowsBreakdownQuery'] =
  queries.getAIUsageAgenticWorkflowsBreakdownQuery;

export const getAIUsageTeamMembersBreakdownQuery: BillingQueries['getAIUsageTeamMembersBreakdownQuery'] =
  queries.getAIUsageTeamMembersBreakdownQuery;
